import React, { Fragment, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import BackComponent from '../../../components/BackComponent'
import Label from '../../helpers/Label'
import Card from '../../helpers/Card'
import Input from '../../helpers/Input'
import LinkButton from '../../helpers/LinkButton'
import Loader from '../../Common/Loader'
import Validation from '../../helpers/Validation'
import { ArrowCircleLeft2 } from 'iconsax-react'
import CancelButton from '../../helpers/CancelButton'
import SaveButton from '../../helpers/SaveButton'
import { GetGladianceUserRole, SaveGladianceUserRole } from '../../../Encapsulation/GladianceDomainEntities/GladianceUserRole'
import { ClearInfo } from '../../../Encapsulation/Utils'
import flasher from '@flasher/flasher'
import { GetGAAProductOutputFunctionType, SaveGAAProductOutputFunctionType } from '../../../Encapsulation/GladianceDomainEntities/GAAProductOutputFunctionType'

function GAAProductOutputFunctionTypeAddEdit() {
    let formMode = 'New';

    let { id } = useParams()
    {
        if (id) {
            document.title = 'Gladiance - Edit Product Output Function Type';
            formMode = 'Edit';
        }
        else {
            document.title = 'Gladiance - Add Product Output Function Type';
        }
    }

    const [loader, setLoader] = useState(false)
    const [errors, setErrors] = useState([])
    const Navigation = useNavigate()
    const [formInfo, setFormInfo] = useState({})

    const handleChange = (e) => {
        setFormInfo(formInfo => ({
            ...formInfo,
            [e.target.name]: e.target.value
        }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('formInfo :', formInfo);
        let result = await SaveGAAProductOutputFunctionType(id, formInfo);
        if (result.Successful == false) {
            flasher.warning(result.Message)
        } else {
            flasher.success('Data Added Successfully')
            if (formMode == 'Edit') {
                Navigation('/product-output-function-type-master');
            }
            else {
                setFormInfo(ClearInfo(formInfo))
            }
        }
    };

    const FetchUserRole = async () => {
        setFormInfo(await GetGAAProductOutputFunctionType(id));
    };

    useEffect(() => {
        if (id) {
            FetchUserRole();
        }
    }, [])

    return (
        <Fragment>
            {loader ? (<Loader />) : (
                <BackComponent title={id ? 'Edit Product Output Function Type' : 'Add Product Output Function Type'} button={
                    <LinkButton to={'/product-output-function-type-master'}>
                        <ArrowCircleLeft2 variant='Bold' className='w-5 h-5 text-default-color' />
                    </LinkButton>
                }>
                    <div className='flex items-center justify-center'>
                        <Card className={'w-full p-6'}>
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
                                    <div>
                                        <Label htmlFor={'Name'} labelText={'Name'} />
                                        <Input inputFocus={true} id={'Name'} type={'text'} name={'Name'} value={formInfo.Name} onChange={handleChange} required={true} />
                                        <Validation error={errors.Name} />
                                    </div>
                                    <div>
                                        <Label htmlFor={'Value'} labelText={'Value'} />
                                        <Input id={'Value'} type={'number'} name={'Value'} min={0} value={formInfo.Value} onChange={handleChange} required={true} />
                                        <Validation error={errors.Value} />
                                    </div>
                                </div>
                                <div className="flex gap-8 justify-center mt-6">
                                    <CancelButton to={'/product-output-function-type-master'} />
                                    <SaveButton text='Save' />
                                </div>
                            </form>
                        </Card>
                    </div>
                </BackComponent>
            )}
        </Fragment>
    )
}
export default GAAProductOutputFunctionTypeAddEdit
